import { Check } from 'lucide-react';
import AppIcon from './AppIcon';

type CartToastProps = {
  message: string;
  visible: boolean;
};

export default function CartToast({ message, visible }: CartToastProps) {
  if (!visible) return null;

  return (
    <div className="cart-toast" role="status" aria-live="polite">
      <span className="cart-toast-icon" aria-hidden="true">
        <AppIcon icon={Check} size={22} strokeWidth={2.5} />
      </span>
      <span className="cart-toast-text">{message}</span>
    </div>
  );
}
